var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg4Clicked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_7064)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_7064",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_7064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.30672 0.283304C-5.84988 -0.262184 -5.63638 -1.21268 -4.91211 -1.4735C1.16176 -3.6608 8.98381 -7.67875 15.1541 -6.29288C21.3244 -4.90701 26.6768 2.06995 31.2318 6.64454C31.775 7.19002 31.5615 8.14052 30.8372 8.40134C24.7634 10.5886 16.9413 14.6066 10.771 13.2207C4.60068 11.8348 -0.751703 4.85789 -5.30672 0.283304Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3473 43.4918C10.8018 44.0349 9.85128 43.8214 9.59045 43.0972C7.40312 37.0233 3.38513 29.2013 4.77097 23.0309C6.15681 16.8606 13.1337 11.5082 17.7083 6.95319C18.2538 6.41004 19.2043 6.62354 19.4651 7.3478C21.6524 13.4217 25.6704 21.2437 24.2846 27.414C22.8987 33.5844 15.9218 38.9368 11.3473 43.4918Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67395 -1.13242C1.86166 -1.88092 0.584609 -1.8354 -0.0567654 -0.936128C-0.885282 0.225538 -1.55645 1.4953 -2.05025 2.84036C-2.77436 4.81278 -3.10288 6.90851 -3.01706 9.00789C-2.93124 11.1073 -2.43277 13.1692 -1.55009 15.0759C-0.948153 16.3762 -0.175588 17.587 0.744982 18.6772C1.45761 19.5211 2.73412 19.4622 3.48261 18.6499L11.6141 9.82527C12.3626 9.01298 12.3109 7.74771 11.4986 6.99921L2.67395 -1.13242Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6986 26.3187C18.5776 26.8575 18.9161 27.3969 19.4632 27.4727C21.4722 27.7509 23.5249 27.516 25.4274 26.7823C27.6417 25.9283 29.5531 24.4368 30.9198 22.4964C32.2865 20.5561 33.0472 18.254 33.1055 15.8814C33.1639 13.5087 32.5174 11.172 31.2478 9.16679C29.9781 7.16156 28.1424 5.57785 25.9727 4.61592C23.803 3.654 21.3968 3.35707 19.0583 3.76268C16.7199 4.1683 14.5542 5.25823 12.8353 6.89466C11.3584 8.3006 10.2682 10.0557 9.66055 11.9907C9.49509 12.5176 9.83785 13.0543 10.3767 13.1754L20.1336 15.367C20.6724 15.488 21.0111 16.023 20.8901 16.5618L18.6986 26.3187Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1103 11.7009C20.8795 10.2335 20.317 8.39353 18.7423 7.87853C15.2088 6.72297 11.3777 6.68241 7.78233 7.80502C3.22545 9.22783 -0.579572 12.4025 -2.79567 16.6308C-5.01177 20.859 -5.45742 25.7943 -4.03458 30.3511C-2.91195 33.9464 -0.69869 37.0737 2.26216 39.3218C3.5817 40.3237 5.41484 39.7392 6.18397 38.2718L13.1472 24.9864L20.1103 11.7009Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#00639C",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_7064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg4Clicked);
export default __webpack_public_path__ + "static/media/profileImg4Clicked.d249232ce851ea19636ab4a970818509.svg";
export { ForwardRef as ReactComponent };